<template>
    <v-layout justify-center>
        <v-responsive max-width="1024" width="100%">
            <list-heading title="교육서비스 등록강좌" />

            <v-data-table v-bind="{ loading, headers, items }" item-key="_id" :items-per-page="-1" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" style="overflow: hidden" ref="data-table">
                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>

                <template #[`item.isMiceNow`]="{ item }">
                    <v-switch v-model="item.isMiceNow" v-bind="attrs_switch__console" @change="(isMiceNow) => update({ _id: item._id, isMiceNow })" />
                </template>
                <template #[`item.isCensored`]="{ item }">
                    <v-switch v-model="item.isCensored" v-bind="attrs_switch__console" @change="(isCensored) => update({ _id: item._id, isCensored })" />
                </template>
            </v-data-table>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />

            <v-fade-transition>
                <v-overlay v-show="loading" light color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch__console } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        ListHeading,
    },
    data: () => ({
        lectures: [],

        limit: 20,
        summary: { totalCount: 0 },

        loading: false,

        attrs_switch__console,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "#",
                    value: "index",
                    width: +80,
                    align: "right",
                },
                {
                    text: "영상 제목",
                    value: "subject",
                },
                {
                    text: "등록일시",
                    value: "createdAt",
                    width: 100,
                    formatter: (value) => value.toDateTime(),
                },
                {
                    text: "MICE Now",
                    value: "isMiceNow",
                    width: +90,
                    align: "center",
                },
                {
                    text: "검열처리",
                    value: "isCensored",
                    width: +90,
                    align: "center",
                },
            ].map((item, index, array) => ({
                ...item,
                divider: index != array.length - 1,
                cellClass: item.cellClass + ` caption`,
                formatter: item.formatter ?? ((value) => value ?? "-"),
            }));
        },
        items() {
            return [...this.lectures].map((item, index) => ({ index: this.summary.totalCount - (this.page - 1) * this.limit - index + 1, ...item }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    methods: {
        async init() {
            this.lectures = [];
            this.loading = false;
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                const { lectures } = await api.console.lectures.gets({
                    headers: { skip, limit },
                    params,
                });
                this.lectures = lectures;
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { lecture } = await api.console.lectures.put(item);
                if (this.loading) this.loading = false;
                this.updateItem(lecture);
                this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        async updateItem(item) {
            const index = this.lectures.findIndex(({ _id }) => _id == item._id);
            if (-1 < index) this.lectures.splice(index, 1, item);
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    .memo-area {
        height: auto !important;

        .v-btn__content {
            display: block;
            text-align: initial;
            white-space: pre-line;
            text-transform: initial;
        }
    }
}
</style>
